import { type Edge } from '@xyflow/react';

function findUpstreamNodes(nodeId: string, edges: Edge[]): string[] {
	const upstreamIds: string[] = [];
	const visited = new Set<string>();

	function traverse(currentId: string) {
		if (visited.has(currentId)) {
			return;
		}
		visited.add(currentId);

		const incomingEdges = edges.filter(edge => edge.target === currentId);
		for (const edge of incomingEdges) {
			upstreamIds.push(edge.source);
			traverse(edge.source);
		}
	}

	traverse(nodeId);
	return upstreamIds;
}

export function wouldCreateCycle(sourceId: string, targetId: string, edges: Edge[]): boolean {
	const upstreamNodes = findUpstreamNodes(sourceId, edges);
	return upstreamNodes.includes(targetId);
}
